export const passwordMaxLength = 25

export const passwordPattern = new RegExp(
  `^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9]).{8,${passwordMaxLength}}$`
)

export const passwordValidationMessage =
  'Password must be 8 to 25 characters and include an uppercase letter, a lowercase letter, and a number.'
